/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing Speed Test — Free WPM Test | Toolverse`)
};

const es_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de Velocidad de Mecanografía — Test de WPM Gratis | Toolverse`)
};

const de_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipptest — Kostenloser WPM-Test | Toolverse`)
};

const nl_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typsnelheidstest — Gratis WPM-test | Toolverse`)
};

const fr_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de vitesse de frappe — Test WPM gratuit | Toolverse`)
};

const it_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test di velocità di digitazione — Test WPM gratuito | Toolverse`)
};

const pt_br2_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de Velocidade de Digitação — Teste de WPM Grátis | Toolverse`)
};

const pt_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de Velocidade de Escrita — Teste de WPM Gratuito | Toolverse`)
};

const ja_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイピングスピードテスト — 無料WPMテスト | Toolverse`)
};

const zh_typing_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打字速度测试 — 免费WPM测试 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_meta_title", locale)
	if (locale === "en") return en_typing_hub_meta_title(inputs)
	if (locale === "es") return es_typing_hub_meta_title(inputs)
	if (locale === "de") return de_typing_hub_meta_title(inputs)
	if (locale === "nl") return nl_typing_hub_meta_title(inputs)
	if (locale === "fr") return fr_typing_hub_meta_title(inputs)
	if (locale === "it") return it_typing_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_meta_title(inputs)
	if (locale === "pt") return pt_typing_hub_meta_title(inputs)
	if (locale === "ja") return ja_typing_hub_meta_title(inputs)
	return zh_typing_hub_meta_title(inputs)
};